import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import DiseaseService from '../../../services/diseaseService';
import { DropdownModel } from "../../../models/dropdownModel";
import { Dropdown } from 'primereact/dropdown';
import { InteractionType } from '../../../common/enums';
import { Editor } from 'primereact/editor';
import { DrugToDiseaseInteractionAdminModel } from "../../../models/activeIngredient";
import { DiseaseForGridModel } from '../../../models/disease/diseaseForGridModel';
import { InputText } from 'primereact/inputtext';
import DiseaseInteractionListDialog from './diseaseInteractionListDialog';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any,
  currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel,
  isDiseaseAddEditDisabled: boolean;
  selectedLangId: number;
}

interface IState {
  isLoading: boolean;
  error: any;
  diseaseDropdown: Array<DropdownModel>;
  interactionSeverityDropdown: Array<DropdownModel>;
  currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel;
  isVisibleDiseaseListDialog: boolean;
}

class DiseaseInteractionAddEditDialog extends React.Component<IProps, IState> {
  diseaseService = new DiseaseService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      diseaseDropdown: Array<DropdownModel>(0),
      interactionSeverityDropdown: Array<DropdownModel>(0),
      currentDiseaseInteraction: this.props.currentDiseaseInteraction,
      isVisibleDiseaseListDialog: false
    }
  }
  componentDidMount() {
    this.initData();
  }

  initData() {
    let severitiesArray: Array<{ label: string, value: number }> = Object
      .keys(InteractionType)
      .filter(key => typeof InteractionType[key] === 'number')
      .map(key => ({ label: key, value: InteractionType[key] }));

    const current: DrugToDiseaseInteractionAdminModel = { ...this.state.currentDiseaseInteraction };
    current.interactionTypeId = InteractionType.Major;

    this.setState({
      interactionSeverityDropdown: severitiesArray,
      currentDiseaseInteraction: current
    });
  }

  handleOkButton = event => {
    event.preventDefault();
    this.props.okClick(this.state.currentDiseaseInteraction);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleInteractionChange = (key, value) => {
    const currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel = { ...this.state.currentDiseaseInteraction };
    currentDiseaseInteraction[key] = value;
    this.setState({ currentDiseaseInteraction: { ...currentDiseaseInteraction } });
  };

  handleDiseaseAddEditClick() {
    this.setState({
      isVisibleDiseaseListDialog: true
    });
  }

  handleDiseaseAddButton = (currentDisease: DiseaseForGridModel) => {
    let currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel = this.state.currentDiseaseInteraction;
    currentDiseaseInteraction.disease = currentDisease;
    this.setState({
      currentDiseaseInteraction: currentDiseaseInteraction,
      isVisibleDiseaseListDialog: false
    });
  }

  handleDiseaseRemoveClick() {
    let currentDiseaseInteraction = this.state.currentDiseaseInteraction;
    currentDiseaseInteraction.disease = new DiseaseForGridModel;

    this.setState({
      currentDiseaseInteraction: currentDiseaseInteraction
    });
  }

  handleDiseaseCancelButton = () => {
    this.setState({
      isVisibleDiseaseListDialog: false
    });
  };

  getDrugToDiseaseValueContent = (key) => {
    let content = this.state.currentDiseaseInteraction.drugToDiseaseInteractionContent.find(r => r.langId == this.props.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleContentChange = (key, value) => {
    const diseaseInteraction: DrugToDiseaseInteractionAdminModel = { ...this.state.currentDiseaseInteraction };
    let content = diseaseInteraction.drugToDiseaseInteractionContent.find(r => r.langId == this.props.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ currentDiseaseInteraction: { ...diseaseInteraction } });
  }

  render() {
    const { interactionSeverityDropdown, currentDiseaseInteraction } = this.state;
    const { isDiseaseAddEditDisabled } = this.props;
    const { disease } = currentDiseaseInteraction;

    let diseaseValue: string = "Select";
    if (disease && disease.diseaseCode) {
      diseaseValue = [disease.diseaseCode, disease.diseaseContent && disease.diseaseContent.length > 0 ?
        disease.diseaseContent.map(r => r.diseaseName).join(' / ') : null].filter(Boolean).join(' / ');
    }

    let diseaseInputButton;
    if (isDiseaseAddEditDisabled) {
      diseaseInputButton = <div><strong>{diseaseValue}</strong></div>;
    } else {
      diseaseInputButton =
        <div className="p-inputgroup">
          <InputText
            readOnly={true}
            onClick={() => this.handleDiseaseAddEditClick()}
            value={diseaseValue}
          />
          <Button
            icon="pi pi-plus"
            className="p-button-success"
            onClick={() => this.handleDiseaseAddEditClick()}
          />
          <Button
            icon="pi pi-times-circle"
            className="p-button-warning"
            onClick={() => this.handleDiseaseRemoveClick()}
          />
        </div>;
    }

    return (
      <>
        <Dialog header="Disease Interaction" responsive={true} width="70%"
          modal={true}
          visible={this.props.isVisible}
          onHide={this.handleCancelButton}
          footer={
            <div>
              <Button label="Add" icon="pi pi-check" disabled={!currentDiseaseInteraction || !currentDiseaseInteraction.disease ||
                !currentDiseaseInteraction.disease.diseaseId || currentDiseaseInteraction.disease.diseaseId == 0}
                onClick={this.handleOkButton} className="p-button-raised" />
              <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
            </div>
          }>
          <div style={{ minHeight: '400px', maxHeight: '550px' }}>
            <div className="p-grid p-fluid p-md-12">
              <div className="p-col-12 p-md-6">
                <label>Disease:</label>
                {diseaseInputButton}
              </div>
              <div className="p-col-12 p-md-6">
                <label>Interaction severity:</label>
                <Dropdown
                  value={currentDiseaseInteraction && currentDiseaseInteraction.interactionTypeId ? currentDiseaseInteraction.interactionTypeId : -1}
                  options={interactionSeverityDropdown}
                  onChange={(e) => this.handleInteractionChange('interactionTypeId', e.value)}
                  style={{ width: '100%' }}
                />
              </div>
              <div className="p-col-12 p-md-12">
                <label>Consumer description:</label>
                <Editor
                  style={{ width: '100%', height: '120px' }}
                  onTextChange={(e) => { this.handleContentChange('consumerDecscription', e.htmlValue) }}
                  value={this.getDrugToDiseaseValueContent('consumerDecscription')}
                />
              </div>
              <div className="p-col-12 p-md-12">
                <label>Professional description:</label>
                <Editor
                  style={{ width: '100%', height: '120px' }}
                  onTextChange={(e) => { this.handleContentChange('professionalDecscription', e.htmlValue) }}
                  value={this.getDrugToDiseaseValueContent('professionalDecscription')}
                />
              </div>
            </div>
          </div>
        </Dialog >

        {this.state.isVisibleDiseaseListDialog ? (
          <DiseaseInteractionListDialog
            selectedDisease={disease}
            addClick={this.handleDiseaseAddButton}
            cancelClick={this.handleDiseaseCancelButton}
            isVisible={this.state.isVisibleDiseaseListDialog}
          />
        ) : null}
      </>
    )
  }
}

export default DiseaseInteractionAddEditDialog;

